export default function convertStringtToKebabCase(str: string) {
  return str.split(" ").join("-").toLowerCase();
}
